import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5a2a625e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2a625e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a2a625e')) {
      api.createRecord('5a2a625e', component.options)
    } else {
      api.reload('5a2a625e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5a2a625e&scoped=true", function () {
      api.rerender('5a2a625e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/detail-pane/index.vue"
export default component.exports